import _ from "lodash";
import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import { useClientDocuments } from "../../../hooks/ClientDocumentsContext";
import { StandardTableSortableHeader } from "../../../components/tables/StandardTable";

const FixedWidthHeader = styled(StandardTableSortableHeader)`
    width: ${props => props.width || 'auto'};
`;

const ClientDocumentsTableHeader = ({ 
    children, 
    property, 
    className, 
    width 
} : Readonly<{
    children: JSX.Element | string,
    className?: any | undefined,
    property: string,
    width?: string
}>) => {
    const { sort, sortTable } = useClientDocuments()!;
    const sortProperties = sort.split(',');
    const isHeaderSorted = _.some(sortProperties, (i: string) => i.includes(property));
    const headerDirection = isHeaderSorted && _.some(sortProperties, (i: string) => i.toLowerCase().includes('+desc')) ? "desc" : null;

    const handleClick = () => property == null || sortTable(property);
    
    return (
        <FixedWidthHeader
            className={classNames(className)}
            active={isHeaderSorted}
            direction={headerDirection}
            onClick={handleClick}
            isSticky={true}
            width={width}
        >
            {children}
        </FixedWidthHeader>
    );
};

export default ClientDocumentsTableHeader;